import {
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import dayjs from 'dayjs'

export default function DateRangeSelector({
  dateRangeMode,
  setDateRangeMode,
  dialogStartDate,
  setDialogStartDate,
  customDateRange,
  setCustomDateRange,
  isFetching,
  isValidDateRange
}) {
  return (
    <div className="d-flex flex-column gap-3">
      <div>
        <strong className="mb-2 d-block">Date Range Mode</strong>
        <ToggleButtonGroup
          value={dateRangeMode}
          exclusive
          onChange={(event, newMode) => {
            if (newMode !== null) {
              setDateRangeMode(newMode)
            }
          }}
          aria-label="date range mode"
        >
          <ToggleButton value="monthly" aria-label="monthly">
            Monthly
          </ToggleButton>
          <ToggleButton value="custom" aria-label="custom range">
            Custom Range
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      
      <div>
        <strong className="mb-2 d-block">
          {dateRangeMode === 'monthly' ? 'Select Month' : 'Select Date Range'}
        </strong>
        {dateRangeMode === 'monthly' ? (
          <DatePicker
            value={dialogStartDate}
            views={['month', 'year']}
            onChange={(val) => setDialogStartDate(val)}
            sx={{ width: '100%' }}
          />
        ) : (
          <div style={{ 
            border: '1px solid #c4c4c4', 
            borderRadius: '4px', 
            padding: '8px 12px',
            backgroundColor: '#fff',
            display: 'inline-block',
            width: '100%'
          }}>
            <DateRangePicker
              onChange={setCustomDateRange}
              value={customDateRange}
              clearIcon={null}
              calendarIcon={null}
              disabled={isFetching}
            />
          </div>
        )}
        {dateRangeMode === 'custom' && customDateRange && customDateRange[0] && customDateRange[1] && 
         !dayjs(customDateRange[0]).isBefore(dayjs(customDateRange[1])) && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            End date must be after start date
          </Typography>
        )}
      </div>
    </div>
  )
}
